export default "__VITE_ASSET__BPIjD$vf__"